// @core/api/endpoints/team/list_my_temporary_roles.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTemporaryRoleAssignmentsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List my temporary roles
 * Returns a paginated list of my temporary roles. Supports filtering and sorting.
 */
export async function ListMyTemporaryRoles(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTemporaryRoleAssignmentsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/my-temporary-roles`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTemporaryRoleAssignmentsResponse>(requestPath, { ...requestOptions, params });
}
